module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Music-65b8f972685d1dadbae47f842556278f2ac4de77333f7d316c3d6ecbbbc2ffb8.svg";